import { useEffect, useState } from "react";
import api from "@/lib/api";
import { initials } from "@/lib/format";
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar";

export default function EmployeeAvatar({
  className = "h-10 w-10",
  fileId,
  name,
  testId,
}) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    let active = true;
    if (!fileId) {
      setUrl(null);
      return undefined;
    }
    api
      .post(`/files/${fileId}/signed-url`)
      .then(({ data }) => {
        if (active) setUrl(`${process.env.REACT_APP_BACKEND_URL}${data.url}`);
      })
      .catch(() => active && setUrl(null));
    return () => {
      active = false;
    };
  }, [fileId]);

  return (
    <Avatar className={className} data-testid={testId}>
      {url && <AvatarImage src={url} alt={name || "Employee"} />}
      <AvatarFallback className="bg-[#255058] text-xs text-white">
        {initials(name || "Nexreq")}
      </AvatarFallback>
    </Avatar>
  );
}
